export const SEARCH_QUERY = 'search/ENTER_QUERY';
export const SEARCH_RESET = 'search/RESET_QUERY';
export const SEARCH_LOAD = 'search/LOAD';
export const SEARCH_LOAD_COMPLETE = 'search/LOAD_COMPLETE';
export const SEARCH_CATEGORY = 'search/CATEGORY';
export const SEARCH_CATEGORY_COMPLETE = 'search/CATEGORY_COMPLETE';
export const SEARCH_CHANGE_PAGE = 'search/CHANGE_PAGE';
export const SEARCH_CHANGE_PAGE_COMPLETE = 'search/CHANGE_PAGE_COMPLETE';
